module.exports = __webpack_public_path__ + "static/img/icon_94_gonggaono.de8bff4b.png";